import { render } from "./modal-bottom-coin-history.html?vue&type=template&id=63a04784&scoped=true&ts=true"
import script from "./modal-bottom-coin-history.vue?vue&type=script&lang=ts"
export * from "./modal-bottom-coin-history.vue?vue&type=script&lang=ts"

import "./modal-bottom-coin-history.scss?vue&type=style&index=0&id=63a04784&scoped=true&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a04784"]])

export default __exports__